import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from '../utils/axios';

interface AuthState {
  user: string | null;
  loading: boolean;
  login: (u: string, p: string) => Promise<void>;
  logout: () => Promise<void>;
}
const Ctx = createContext<AuthState>({} as AuthState);
export const useAuth = () => useContext(Ctx);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get('/me')
      .then((r) => setUser(r.data.username))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const login = async (u: string, p: string) => {
    const r = await axios.post('/login', { username: u, password: p });
    setUser(r.data.username);
  };
  const logout = async () => {
    try { await axios.post('/logout'); } finally { setUser(null); }
  };
  return <Ctx.Provider value={{ user, loading, login, logout }}>{children}</Ctx.Provider>;
};
